<template>
  <div class="main-nav-bar-container">
    <div class="main-nav-bar">
      <router-link to="/fundingnew/calendar" class="item" @click.native="trackingAction('calendar_click', 'calendar')">
        <div class="inner">
          <div class="icon normal">
            <img src="@images/rebuild/icon_calendar.png" alt="夜计划日历" />
          </div>
          <div class="icon active">
            <img src="@images/rebuild/icon_calendar_active.png" alt="夜计划日历" />
          </div>
          <h5 class="title">夜计划日历</h5>
        </div>
      </router-link>
      <router-link to="/fundingnew/index" class="item" @click.native="trackingAction('Yjhbcmenu_click', 'plan')">
        <div class="inner">
          <div class="icon normal">
            <img src="@images/rebuild/icon_funding.png" alt="绝对夜计划" />
          </div>
          <div class="icon active">
            <img src="@images/rebuild/icon_funding_active.png" alt="绝对夜计划" />
          </div>
          <h5 class="title">悬赏夜计划</h5>
        </div>
      </router-link>
      <router-link to="/scene/list" class="item" @click.native="trackingAction('ugc_photo', 'ugc')">
        <div class="inner">
          <div class="icon normal">
            <img src="@images/rebuild/icon_ugc.png" alt="夜计划现场" />
          </div>
          <div class="icon active">
            <img src="@images/rebuild/icon_ugc_active.png" alt="夜计划现场" />
          </div>
          <h5 class="title">夜计划现场</h5>
        </div>
      </router-link>
      <router-link to="/fundingnew/my/submissions" class="item" @click.native="trackingAction('my_click', 'center')">
        <div class="inner">
          <div class="icon normal">
            <img src="@images/rebuild/icon_profile.png" alt="我的" />
          </div>
          <div class="icon active">
            <img src="@images/rebuild/icon_profile_active.png" alt="我的" />
          </div>
          <h5 class="title">我的</h5>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { behavior } from '@/utils/behavior'
export default {
  name: 'RebuildNavBar',
  methods: {
    trackingAction(action, name) {
      _jcq.push(['_track', action])

      if (name === 'calendar') {
        behavior({ behavior_code: 'prc_bhv_abs_menu_bc' })
      }
      if (name === 'plan') {
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc6' })
      }
      if (name === 'ugc') {
        behavior({ behavior_code: 'prc_bhv_abs_pw_bc5' })
      }
      if (name === 'center') {
        behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc1' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-nav-bar-container {
  position: fixed;
  z-index: 12;
  bottom: 0;
  left: 0;
  width: 100%;
  // padding: 0 10px;
  background-color: nth($darkblue, 1);
  @include respond-to(iphonex) {
    padding-bottom: 25px;
  }
  @include respond-to(desktop) {
    //top: $top-height-descktop - $nav-height-descktop;
    top: 115px;
    bottom: auto;
    background-color: transparent;
  }
}
.main-nav-bar {
  @include display-flex;
  width: 100%;
  @include respond-to(desktop) {
    display: table;
    max-width: 600px;
    margin: 0 auto;
    background-color: transparent;
  }
  .item {
    @include display-flex;
    @include flex(1);
    height: $nav-height;
    color: rgba(255, 255, 255, 0.7);
    overflow: hidden;
    align-items: center;
    justify-content: center;
    @include respond-to(desktop) {
      display: table-cell;
      position: relative;
      width: 33.3%;
      height: $nav-height-descktop;
      text-align: center;
      vertical-align: middle;
    }
    .icon {
      width: 25px;
      height: 25px;
      margin: 0 auto 2px;
      &.normal {
        display: block;
        @include respond-to(desktop) {
          display: inline-block;
          margin-top: -6px;
          vertical-align: middle;
        }
      }
      &.active {
        display: none;
      }
      & > img {
        width: 100%;
      }
      &.showroom {
        width: 4.9rem;
      }
      &.showroom.active {
        width: 4.9rem;
      }
    }
    .title {
      text-align: center;
      height: 20px;
      line-height: 20px;
      font-size: $font-sm;
      font-weight: bold;
      @include respond-to(desktop) {
        display: inline-block;
        font-size: 1.6rem;
      }
    }
    &:active,
    &.router-link-active {
      color: #fff;
      background: url('~@static/funding/mb/bar_bg.png') repeat-x;
      background-size: cover;
      @include respond-to(desktop) {
        background: transparent;
      }
      .icon {
        &.normal {
          display: none;
        }
        &.active {
          display: block;
          @include respond-to(desktop) {
            display: inline-block;
            margin-top: -6px;
            vertical-align: middle;
          }
        }
      }
      .title {
        color: #ef07c7;
        font-weight: bold;
        @include respond-to(desktop) {
          // border-bottom: 2px solid rgb(153, 149, 149);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RebuildNavBar.vue